import React, { Component } from 'react';
import { Tabs } from 'antd';
import { login } from '../../store/actions/index';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { axiosAuth } from 'Axios.js';
import WithError from 'HOC/Error/WithError';
import * as Page from '../../HOC/Layout/PageContainer';

import styles from './AuthPage.module.css';

import LoginForm from '../../components/Forms/LoginForm/LoginForm';
import ForgotForm from '../../components/Forms/ForgotForm/ForgotForm';

const TabPane = Tabs.TabPane;

const { Container } = Page;

class AuthPage extends Component {
  state = { current: 'SignIn' };

  onTabChange = key => {
    this.setState(prevState => ({ ...prevState, current: key }));
  };

  render() {
    const { from } = this.props.location.state || { from: { pathname: '/' } };
    const { isLoggedIn } = this.props;

    if (isLoggedIn) return <Redirect to={from} />;
    else
      return (
        <Container type="3x3">
          <Tabs
            className={styles.Tabs}
            onChange={this.onTabChange}
            type="card"
            animated={true}
            activeKey={this.state.current}
          >
            <TabPane tab="Sign In" key="SignIn">
              <LoginForm onTabChange={this.onTabChange} onLogin={this.props.login} />
            </TabPane>
            <TabPane tab="" key="ForgotPassword" disabled>
              <ForgotForm />
            </TabPane>
          </Tabs>
        </Container>
      );
  }
}

const mapStateToProps = state => {
  const { authenticated, loading } = state.auth;
  const isLoading = loading;
  const isLoggedIn = authenticated;

  return { isLoading, isLoggedIn };
};

const mapDispatchToProps = { login };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithError(AuthPage, axiosAuth));



// WEBPACK FOOTER //
// ./src/containers/Auth/AuthPage.js